import { createStructuredSelector } from "reselect";
import { fetchRAGState } from "../Epics/Grants/Pages/RecommendGrant/Selectors/RecommendGrantPageSelectors";
import { selectActiveStepNumber,selectStepConfig,selectStepperUpdateIndex } from "../selectors/globalSelectors";
//recommend an exchange 

export const getRecommendAnExchange = (state)=>{
    return state.recommendAnExchange
}

//recommend an exchange end 

export const getCarousal = state => {
    return  state.carousel
}
export const getGrantsDashBoard = state =>{
    return state.grantsDashboard
}
export const getCarousalData = state =>{
    return getCarousal(state).carouselData
}

export const getGeminiFilter = (state)=>{
    return fetchRAGState(state).geminiFilter;
}

export const selectData = state=>{
    return getCarousalData(state).data
}

export const selectIsLoading = state=>{
    return getCarousalData(state).isLoading
}
export const selectShowFilter = state => {
    return getGeminiFilter(state).showFilter
}

export const selectRAGFrom = state => {
    return fetchRAGState(state).from 
}
export const  grantGeminiFilter = state =>{
    return getGrantsDashBoard(state).geminiFilter
}
export const selectGeminiShowFilter = state =>{
    return grantGeminiFilter(state).showFilter
}

export const getGrantAgreements = state => {
    return state.grantAgreements
}

export const grantAgreementGeminiFilter = state =>{
    return getGrantAgreements(state).geminiFilter
}
export const selectGrantAgreementShowFilter = (state)=>grantAgreementGeminiFilter(state).showFilter;
export const selectGetGrantsDashBoardFrom = state => {
    return getGrantsDashBoard(state).from;
}
export const selectGrantAgreementsFrom = (state)=>{
    return getGrantAgreements(state).from
}

//Geography selectors

export const selectSearchCity = (state)=>{
    return fetchRAGState(state).searchCity;
} 

export const selectSeachCityData = state => {
    return selectSearchCity(state).data;
}
export const selectCityLoader = state => {
    return fetchRAGState(state).cityLoader;
}
export const selectCityLoaderIsLoading = state => {
    return selectCityLoader(state).isLoading;
}
export const selectSearchCounty = state => {
    return fetchRAGState(state).searchCounty
}
export const selectSearchCountyData = state => {
    return selectSearchCounty(state).data
}
export const selectCountyLoader = state => {
    return fetchRAGState(state).countyLoader;
}
export const selectCountyLoaderIsloading = state => {
    return selectCityLoader(state).isLoading;
}

export const geoGraphyDerivedStates = createStructuredSelector({
    searchCity:selectSeachCityData,
    isLoading:selectCityLoaderIsLoading,
    searchCounty:selectSearchCountyData,
    isCountyLoading:selectCountyLoaderIsloading
})

//Geography selectors End 

//Add Link To Pill

export const selectActiveConfirmation = (state)=>{return getRecommendAnExchange(state).activeConfirmation}
export const addLinkToPillDerivedStates = createStructuredSelector({
    activeConfirmation:selectActiveConfirmation
})

//Add Link to pill end 

//EditLink To pill

export const selectViewChanges = (state) => {
    return state.viewExchanges||{}
}


export const getREdata = (state)=>{
    return selectViewChanges(state).REData||{}
}

export const selectRecurringExchange = state => {
    const {recurringExchange} =  getREdata(state);
    return recurringExchange ||{};
}

export const selectAllocationType = (state)=>{
    return selectRecurringExchange(state).allocationType
}

export const selectSingleExchange = state=>{
    const {singleExchange} = selectViewChanges(state).SEData||{};
    return singleExchange || {};
}

export const selectInstructionType = state => {
    return selectSingleExchange(state).instructionType;
}

export const selectExchangeDataRE = state=>{
    return getREdata(state)
}

export const editLinkToPillsDerivedStates = createStructuredSelector({
    activeConfirmation:selectActiveConfirmation,
    allocationType:selectAllocationType,
    instructionType:selectInstructionType,
    exchangeDataRE:selectExchangeDataRE  
})

//Edit Link to pill end 

//infoRectangleNPA 

export const selectNpaFormReducer = state => {
    return state.npaFormReducer||{}
}
export const selectTempJson = (state)=>{
    const {tempJSON = {}} = selectNpaFormReducer(state);
    return (tempJSON.tempJSON || {}).tempJSON
}


export const selectTypeActive  = state => {
    return getRecommendAnExchange(state).typeActive
}

export const stepperDerivedStates = createStructuredSelector({
    activeStepNumber:  selectActiveStepNumber,
    stepConfig: selectStepConfig,
    stepperUpdateIndex:selectStepperUpdateIndex,
    activeStepName:selectTypeActive
})


export const charitySearchDerivedStates = createStructuredSelector({
    showGeminiFilter:selectShowFilter,
    counterFrom:selectRAGFrom,
    grantShowGeminiFilter:selectGeminiShowFilter,
    agreementShowGeminiFilter:selectGrantAgreementShowFilter,
    grantcounterFrom:selectGetGrantsDashBoardFrom,
    agreementcounterFrom:selectGrantAgreementsFrom
})

//with fetching 

export const getDataByActionParam = (state,{page}) => {
    return state.page
}

export const getAccountDataWithFetching = (state,fetchActionParams)=>{
    const {accountData} = getDataByActionParam(state,fetchActionParams);
    return accountData;
};

export const getDataWithFetching = (state,fetchActionParams) => {
    const {data} = getAccountDataWithFetching(state,fetchActionParams);
    return data;
}

export const getisLoadingWithFetching = (state,fetchActionParams) => {
    const {isLoading} = getAccountDataWithFetching(state,fetchActionParams);
    return isLoading;
}

export const getErrorWithFetching = (state,fetchActionParams) => {
    const {error} = getAccountDataWithFetching(state,fetchActionParams);
    return error;
}

export const withFetchingDerivedStates = createStructuredSelector({
    accountData:getDataWithFetching,
    isLoading:getisLoadingWithFetching,
    error:getErrorWithFetching
})

//with fetching end
